export var RiskAssessmentResultControlType;
(function (RiskAssessmentResultControlType) {
    RiskAssessmentResultControlType["Controlled"] = "Controlled";
    RiskAssessmentResultControlType["Uncontrolled"] = "Uncontrolled";
})(RiskAssessmentResultControlType || (RiskAssessmentResultControlType = {}));
//# sourceMappingURL=risk-assessment-result-control-type.js.map